<div [class.noPadding]="noPadding" fxLayout="row" [fxLayoutAlign]="fxLayoutAlign">
  @if (!isDecember && !isJanuary && !isSkiingPeriod) {
    <fa-icon icon="spinner" size="{{size}}" [spin]="true"></fa-icon>
  }
  @if (!isDecember && isJanuary) {
    <fa-icon icon="snowflake" size="{{size}}" [spin]="true" style="color: gainsboro;"></fa-icon>
  }
  @if (!isDecember && isSkiingPeriod) {
    <fa-icon icon="skiing" size="{{size}}" [spin]="true" style="color: darkblue;"></fa-icon>
  }
  @if (isDecember && !isChristmasPeriod) {
    <fa-icon icon="tree" size="{{size}}" [spin]="true" style="color: darkgreen;"></fa-icon>
  }
  @if (isDecember && isChristmasPeriod) {
    <fa-icon icon="gift" size="{{size}}" [spin]="true" style="color: red;"></fa-icon>
  }
</div>
